// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c4b3bbb","257":"e1001602","455":"24dc4607","977":"c996bab0"}[chunkId] + ".chunk.js";
};